export default "__VITE_ASSET__LUhQS3PJ__"